import type { ReactNode } from 'react';
import styles from './EditRelevanceLink.module.scss';
import FontAwesomeIcon, {
  solidSliders
} from 'common/components/FontAwesomeIcon';
import { editStaffVenueRelevanceScoresPath } from 'routes';

export const editRelevanceLinkWrapperClass = styles.wrapper;

type Props = { venueId: number };

export function EditRelevanceLink(props: Props): ReactNode {
  return (
    <a
      href={editStaffVenueRelevanceScoresPath({ venueId: props.venueId })}
      className={styles.link}
      title="Edit relevance scores for this venue"
    >
      <FontAwesomeIcon icon={solidSliders} />
    </a>
  );
}
